import React from 'react';
import { common } from '@kurtosys/ksys-app-template';
import { IAppContext } from '@kurtosys/types/helpers/AnalyticsHelper/IAppContext.js';
import { observer } from 'mobx-react';

import { AnalyticsContext, ComponentBase, InjectedStyledComponent, KEYS } from '../../../shared/index.js';
import Link from '../../base/Link/Link.js';

import {
	IBulkDocumentDownloadConfiguration,
	IBulkDocumentDownloadProps,
	IBulkDocumentDownloadState,
} from './models/index.js';
import LinkButton from './styledComponents/LinkButton.js';
import Wrapper from './styledComponents/Wrapper.js';
import {
	BULK_DOCUMENT_DOWNLOAD_CATEGORY_KEY,
	BULK_DOCUMENT_DOWNLOAD_COMPONENT_KEY,
} from './BulkDocumentDownload.meta.js';

const ACCEPT_KEYS = [KEYS.ENTER, KEYS.SPACE, KEYS.SPACEBAR];

export class BulkDocumentDownload extends ComponentBase<
	IBulkDocumentDownloadProps,
	IBulkDocumentDownloadState,
	IBulkDocumentDownloadConfiguration
> {
	categoryKey = BULK_DOCUMENT_DOWNLOAD_CATEGORY_KEY;
	componentKey = BULK_DOCUMENT_DOWNLOAD_COMPONENT_KEY;
	analyticsHelper: common.helpers.AnalyticsHelper<IAppContext> | undefined;

	constructor(props: IBulkDocumentDownloadProps) {
		super(props);
	}

	onClick = (e: React.MouseEvent<HTMLAnchorElement, globalThis.MouseEvent>) => {
		this.handleDownload();
	};

	onKeyUp = (e: React.KeyboardEvent<HTMLAnchorElement>) => {
		const { key } = e;
		if (ACCEPT_KEYS.indexOf(key as KEYS) !== -1) {
			this.handleDownload();
		}
	};

	handleDownload = () => {
		const { documentIds, onDownloadClick } = this.props;
		const analyticsHelper = this.analyticsHelper;
		if (onDownloadClick) {
			onDownloadClick(documentIds);
		}

		// If there is no click event then log the default context, else assume that the on click will log
		if (!onDownloadClick && analyticsHelper) {
			analyticsHelper.logEvent({
				event: 'document_click',
				eventType: 'click',
				context: {
					zipDocumentIds: documentIds,
				},
			});
		}
	};

	render() {
		const { className, label } = this.props;
		return (
			<AnalyticsContext.Consumer>
				{(analyticsHelper) => {
					this.analyticsHelper = analyticsHelper;
					return (
						<Wrapper className={className}>
							<LinkButton>
								<Link role="button" tabIndex={0} onClick={this.onClick} onKeyUp={this.onKeyUp}>
									{label}
								</Link>
							</LinkButton>
						</Wrapper>
					);
				}}
			</AnalyticsContext.Consumer>
		);
	}
}

export default InjectedStyledComponent(
	observer(BulkDocumentDownload),
	BULK_DOCUMENT_DOWNLOAD_CATEGORY_KEY,
	BULK_DOCUMENT_DOWNLOAD_COMPONENT_KEY,
);
